import { Language, LANGUAGE_ESTONIAN, SUPPORTED_LANGUAGES } from './types';

const LANGUAGE_STORAGE_KEY = 'language';

const isSupportedLanguage = (language: unknown): language is Language =>
  SUPPORTED_LANGUAGES.includes(language as Language);

export const getStoredLanguage = (): Language => {
  if (!('localStorage' in globalThis)) {
    return LANGUAGE_ESTONIAN;
  }

  const language = globalThis.localStorage.getItem(LANGUAGE_STORAGE_KEY);

  return isSupportedLanguage(language) ? language : LANGUAGE_ESTONIAN;
};

export const setStoredLanguage = (language: Language) => {
  if ('localStorage' in globalThis) {
    globalThis.localStorage.setItem(LANGUAGE_STORAGE_KEY, language);
  }
};
